import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.scss';

const { number, string, array, object, func } = PropTypes;

class Radios extends React.Component {
  static propTypes = {
    items: array.isRequired,
    onClick: func.isRequired,
    selectedValue: string,
  };

  itemClicked(itemValue, e) {
    this.props.onClick(itemValue);
  }

  hasError() {
    return this.props.errors && this.props.errors.length > 0;
  }

  renderError() {
    if (this.hasError()) {
      return <span className="ar-radio-error">{this.props.errors[0]}</span>;
    }
    return null;
  }

  render() {
    const radioWrapperClasses = classnames('ar-radio-wrapper', {
      error: this.hasError(),
    });
    return (
      <div
        data-testid={this.props['data-testid']}
        className={radioWrapperClasses}
      >
        {this.props.items.map((item, i) => {
          const cssClass =
            this.props.selectedValue === item.text
              ? 'ar-radio-icon af-checkmark brand-bg'
              : 'ar-radio-icon';
          return (
            <div
              key={i}
              onClick={this.itemClicked.bind(this, item.text)}
              className="ar-radio-item"
            >
              <span className="ar-radio-icon-wrapper">
                <i className={cssClass} data-testid="radio-icon" />
              </span>
              <span className="ar-radio-text">{item.text}</span>
            </div>
          );
        })}
        {this.props.subtext && (
          <div
            className="question-subtext contains-brand-link"
            dangerouslySetInnerHTML={{ __html: this.props.subtext }}
          />
        )}
        {this.renderError()}
      </div>
    );
  }
}

export default Radios;
